import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewHomeExperienceService } from "@webapp/home/services/new-home-experience.service";

@Component({
  selector: "home-top-nav-bar",
  templateUrl: "./home-top-nav-bar.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTopNavBarComponent {
  public showBetaLabel: boolean;

  constructor(private newHomeExperienceService: NewHomeExperienceService) {
    this.showBetaLabel = this.newHomeExperienceService.showBetaLabels();
  }
}
